<template>
  <div class="home">

    <div class="div-slider">
      <slider v-if="!errorSlider" :item="images"></slider>
      <img v-else src="../../assets/img/home/1.jpg" style="width:100%" alt="">
    </div>

    <!-- reserva -->
    <div class="container reserva">
      <reserva v-bind:header="true"></reserva>
    </div>

    <!-- Resumo -->
    <div class="container-flex" id="reservar">
      <div class="container" id="reservar-container">
        <h1>{{$t('telas.sobre_nos.pousada')}} Tranquilândia Village</h1>
        <hr>

        <div class="row" id="video">
          <div class="col-10 offset-1
                      col-sm-10 offset-sm-1
                      col-md-8 offset-md-2
                      col-lg-8 offset-lg-2
                      col-xl-8 offset-xl-2">
            <video id="video-iframe" src="../../assets/video/tranquilandia.mp4"
                   style="border-radius:5px"
                   poster="../../assets/img/poster.jpeg"
                   autoplay
                   loop
                   controls
                   muted>
              <p>Houve um erro ao carregar o vídeo.</p>
              <p>Clique <a href="https://vimeo.com/285991646" target="_blank">aqui</a> para ver.</p>
            </video>
          </div>
        </div> <!-- video -->

        <div class="row">
          <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" id="sobre-nos">
            <h4>{{$t('telas.sobre_nos.titulo')}}</h4>
            <br>
            <p> {{$t('telas.sobre_nos.descricao.sobre_p1')}} </p>
            <p> {{$t('telas.sobre_nos.descricao.sobre_p2')}} </p>

            <div class="input-group mb-2">
              <button @click="rota('Evaluation')" type="button" class="btn btn-contact-assessments">{{$t('telas.sobre_nos.botao.avaliacoes')}}</button>
            </div>

            <hr>
          </div>
          <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" id="comodidade">
            <h4>{{$t('telas.sobre_nos.comodidades')}}</h4>
            <br>
            <ul>
              <li> <img src="../../assets/png/glyphicons-74-wifi.png" class="png-icons" alt="Internet"> {{$t('telas.sobre_nos.descricao.internet')}}</li>
              <li> <img src="../../assets/png/glyphicons-261-pool.png" class="png-icons" alt="Piscina"> {{$t('telas.sobre_nos.descricao.piscina')}}</li>
              <li> <img src="../../assets/png/glyphicons-87-display.png" class="png-icons" alt="Entretenimento"> {{$t('telas.sobre_nos.descricao.entretenimento')}}</li>
              <li> <img src="../../assets/png/glyphicons-542-cat.png" class="png-icons" alt="Animal de estimação"> {{$t('telas.sobre_nos.descricao.animais')}}</li>
              <li> <img src="../../assets/png/glyphicons-277-cutlery.png" class="png-icons" alt="Alimentos"> {{$t('telas.sobre_nos.descricao.restaurante')}}</li>
              <li> <img src="../../assets/png/glyphicons-363-smoking.png" class="png-icons" alt="Quartos"> {{$t('telas.sobre_nos.descricao.fumantes')}}</li>
              <li> <img src="../../assets/png/glyphicons-29-cars.png" class="png-icons" alt="Transfer"> {{$t('telas.sobre_nos.descricao.transfer')}}</li>
              <li> <img src="../../assets/png/glyphicons-720-parking.png" class="png-icons" alt="Estacionamento"> {{$t('telas.sobre_nos.descricao.estacionamento')}}</li>
              <li> <img src="../../assets/png/glyphicons-68-cleaning.png" class="png-icons" alt="Limpeza"> {{$t('telas.sobre_nos.descricao.limpeza')}}</li>
              <li> <img src="../../assets/png/glyphicons-22-snowflake.png" class="png-icons" alt="Ar condicionado"> {{$t('telas.sobre_nos.descricao.ar_condicionado')}}</li>
              <li> <img src="../../assets/png/glyphicons-490-handshake.png" class="png-icons" alt="Recepção"> {{$t('telas.sobre_nos.descricao.recepcao')}}</li>
            </ul>

            <div class="input-group mb-2">
              <button @click="rota('Convenience')" type="button" class="btn btn-comodidade-ver-mais">{{$t('telas.sobre_nos.botao.ver_mais')}}</button>
            </div>

            <hr>
          </div>
        </div>

        <!-- <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" id="premios">
            <h4>{{$t('telas.premios.titulo')}}</h4>
            <br>

            <div id="TA_certificateOfExcellence882" class="TA_certificateOfExcellence">
              <ul id="JTuHjEaTgm" class="TA_links ZiLdO26BaFb">
                <li id="0NY3gONvkMT" class="t9qamkcF">
                  <a target="_blank" href="https://www.tripadvisor.com.br/Hotel_Review-g635974-d1557902-Reviews-Pousada_Tranquilandia_Village-Canoa_Quebrada_State_of_Ceara.html">
                    <img src="https://www.tripadvisor.com.br/img/cdsi/img2/awards/v2/tchotel_2020_LL-14348-2.png" alt="TripAdvisor" class="widCOEImg" id="CDSWIDCOELOGO"/>
                  </a>

                  <a class="test" target="_blank" href="https://www.tripadvisor.com.br/Hotel_Review-g635974-d1557902-Reviews-Pousada_Tranquilandia_Village-Canoa_Quebrada_State_of_Ceara.html">
                    <img src="https://www.tripadvisor.com.br/img/cdsi/img2/badges/ollie-11424-2.gif" alt="TripAdvisor"/>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div> -->

      </div>
    </div>

  </div> <!-- home -->
</template>

<script>
import reserva from '../../components/reservation-component/ReservationComponent'
import slider from '../../components/slider/Slider'
import ShModal from '../../components/modal/Modal'
import { urlBase } from '../../../config/url'

export default {
  name: 'Home',

  data() {
    return {
      images: {
        id: '1',
        imagesUrl: [],
        slideError: false
      }
    }
  },

  components: {
    reserva,
    slider,
    ShModal
  },

  computed: {
    errorSlider() {
      return this.slideError
    }
  },

  created() {
    this.slideError = false

    try {
      for(let i = 1; i <= 18; i++) {
        this.images.imagesUrl.push(require(`@/assets/img/home/${i}.jpg`))
      }
    } catch(err) {
      this.slideError = true
      console.log(err)
    }
  },

  methods: {
    rota(route){
      this.$router.push({name: route});
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css?family=Quicksand');

/* MODAL */
.modal-content {
  max-height: 90%;
  max-width: 100%;
  overflow: auto;
}
.modal-content .modal-covid {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .text-info-vacinacao {
    font-size: 24px;
  }

  @media(min-width: 993px) { // ≥1200px
    img.img-info-covid {
      width: 60%;
    }
  }
  @media(max-width: 992px) { // ≥992px
    img.img-info-covid {
      width: 70%;
    }
  }
  @media(max-width: 768px) { // ≥768px
    img.img-info-covid {
      width: 80%;
    }
  }
  @media(max-width: 576px) { //<576px
    img.img-info-covid {
      width: 90%;
    }
  }
}

.modal-content .modal-covid .item {
  background-color: grey;
  width: 5px;
  height: 5px;
  border-radius: 5px;
  margin: 5px;
}

.modal-content .modal-covid .active {
  background-color: blue;
}

.modal-content .modal-covid img {
  margin: 10px 0;
}

.modal-content .modal-covid h4,
.modal-content .modal-covid p {
  text-align: center
}

/* SLIDE */
.div-slider {
   margin: 0;
   padding: 0 !important
}

/* Covid19 */
/* .covid19 {

} */

/* RESERVAS */
.home {
  background-color: white;
  color: black;
  font-family: 'Quicksand', sans-serif;
}
.home .container-flex #ExemploCarrousel {
  background-color: white;
}
@media (max-width: 576px) {
  .home .container-flex #ExemploCarrousel .carousel-inner .carousel-item {
    height: 300px;
  }
  .home .container-flex #ExemploCarrousel .carousel-inner .carousel-item img {
    margin-top: 75px;
    -moz-transform: scale(2.0);
  	-webkit-transform: scale(2.0);
  	transform: scale(2.0);
  }
}

#reservar {
  color: black;
}
#reservar #reservar-container {
  padding-top: 50px;
  padding-bottom: 100px;
}
#reservar #reservar-container h1,
#reservar #reservar-container h4,
#reservar #video h4 {
  width: 100%;
  text-align: center;
}
#reservar #reservar-container h1 {
  color: rgb(118, 106, 49);
}
#reservar #reservar-container h4 {
  color: #444;
}
#reservar #video-iframe {
  margin: 40px auto;
  width: 100%;
  box-shadow: 3px 3px 5px #666;
}
#reservar #reservar-container p {
  text-align: center;
  font-weight: 500;
}
div.reserva {
  color: black;
}

/* COMODIDADES */
#reservar #reservar-container #comodidade ul {
  list-style-type: none;
}

#reservar #reservar-container #comodidade img.png-icons {
  max-width: 20px;
  max-height: 20px;
  margin-right: 5px;
  margin-bottom: 5px;
}

/* BTN COMODIDADE E AVALIAÇÕES */
button.btn-comodidade-ver-mais,
button.btn-contact-assessments {
  margin: 0 auto;
  background-color: rgb(23, 162, 184);
  color: white;
  transition: background-color 0.5s;
  box-shadow: 3px 3px 5px #666;
}
button.btn-comodidade-ver-mais:HOVER,
button.btn-contact-assessments:HOVER {
  background-color: rgb(0, 20, 45);
}
</style>



// WEBPACK FOOTER //
// src/pages/home/Home.vue